export const CASE_TIME_CONTEXT = '$$CASE_TIMER_CONTEXT'
